export const config = {
  sourceLanguage: { required: true, value: null },
  targetLanguage: { required: true, value: [], disabled: true }
};
